import axios from '../utils/index';
import { Pat } from '@/typings/request';

/** Omit empty strings so Spring does not receive `startTime=` / `keyword=` etc. */
function listQueryParams(params?: Pat): Pat {
    if (!params) return {};
    const out: Pat = {};
    for (const key of Object.keys(params)) {
        const v = params[key];
        if (v !== '' && v !== undefined && v !== null) {
            out[key] = v;
        }
    }
    return out;
}

const taskerCategoriesApi = {
    async getList(params?: Pat) {
        return axios.get(`/tasker-category/list`, { params: listQueryParams(params) });
    },
    async create(data: Pat) {
        return axios.post(`/tasker-category`, data);
    },
    async update(taskerCategoryId: string, data: Pat) {
        return axios.put(`/tasker-category/${taskerCategoryId}`, data);
    },
    async delete(taskerCategoryId: string) {
        return axios.delete(`/tasker-category/${taskerCategoryId}`);
    },
};

export default taskerCategoriesApi;
